var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminFilePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3625 25H7.5L15 17.5L17.35 19.85C18.125 18.625 19.2 17.625 20.5 17L22.5 15V16.3625C22.9125 16.3 23.325 16.25 23.75 16.25C24.175 16.25 24.5875 16.3 25 16.3625V10L17.5 2.5H7.5C6.1125 2.5 5 3.6125 5 5V25C5 25.663 5.26339 26.2989 5.73223 26.7678C6.20107 27.2366 6.83696 27.5 7.5 27.5H17.2625C16.825 26.7375 16.5125 25.9 16.3625 25ZM16.25 4.375L23.125 11.25H16.25V4.375ZM10 11.25C10.663 11.25 11.2989 11.5134 11.7678 11.9822C12.2366 12.4511 12.5 13.087 12.5 13.75C12.5 14.413 12.2366 15.0489 11.7678 15.5178C11.2989 15.9866 10.663 16.25 10 16.25C8.6125 16.25 7.5 15.1375 7.5 13.75C7.5 12.3625 8.625 11.25 10 11.25ZM25 18.75V22.5H28.75V25H25V28.75H22.5V25H18.75V22.5H22.5V18.75H25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminFilePlus);
export default __webpack_public_path__ + "static/media/adminFilePlus.1ecf1959a3e85b40e9f804c6de20ca12.svg";
export { ForwardRef as ReactComponent };